<template>
    <div>
        <!-- Tiêu đề trang -->
        <div class="text-center my-3">
            <h3 class="font-weight-bold">
                <v-icon>mdi-account-circle</v-icon>
                DANH SÁCH NGƯỜI DÙNG
            </h3>
        </div>


        <v-container>
            <v-row class="d-flex justify-center mx-auto" style="width: auto">
                <v-col cols="12" md="9">
                    <v-combobox hide-details :return-object="false" v-model="cbxCompany" :items="dataCompany"
                        item-title="CompanyName" item-value="CompanyID" label="Chọn công ty"></v-combobox>
                </v-col>
                <v-col cols="12" md="2" class="d-flex align-center justify-center ml-n4">
                    <v-btn :disabled="cbxCompany === null ? true : false" elevation="0" color="primary"
                        @click="openDialogUpdateUser(null)">
                        <v-icon class="mr-2">mdi-plus-circle</v-icon>
                        Thêm mới
                    </v-btn>
                </v-col>
            </v-row>
        </v-container>


        <!-- Bảng danh sách người dùng -->
        <v-table style="width: 1000px" class="mx-auto">
            <thead>
                <tr>
                    <th>Tên đăng nhập</th>
                    <th>Họ tên</th>          
                    <th>Email</th>
                    <th>Quyền đang có</th>
                    <th>Thao tác</th>
                </tr>
            </thead>
            <tbody>
                <tr v-if="userList.length === 0">
                    <td colspan="5" class="text-center">Không có dữ liệu để hiển thị</td>
                </tr>
                <tr v-for="user in userList" :key="user.Username">
                    <td>{{ user.Username }}</td>
                    <td>{{ user.FullName }}</td>
                    <td>{{ user.Email }}</td>
                    <td>
                        <div>
                            <v-btn color="primary" size="small" @click="()=>{getPermission(user.UserID); showDialogPermission=true;}" variant="text">
                                xem quyền
                            </v-btn>
                        </div>
                    </td>

                    <td>
                        <div style="display: flex; gap: 2px; align-items: center;">
                            <v-icon color="blue" @click="openDialogUpdateUser(user)">mdi-pencil</v-icon>
                            <v-icon color="red" @click="confirmDelete(user)">mdi-delete</v-icon>
                        </div>
                    </td>
                </tr>
            </tbody>

        </v-table>


        


        <!-- Hộp thoại Thêm/Sửa -->
        <v-dialog v-model="showDialogUpdate" max-width="500px">
            <v-card prepend-icon="mdi-account-tie" :title="dialogTitle">
                <v-divider></v-divider>
                <v-card-text>
                    <v-text-field v-model="selectedUser.Username" label="Tên đăng nhập" outlined></v-text-field>
                    <v-text-field v-model="selectedUser.Password" label="Mật khẩu" outlined></v-text-field>
                    <v-text-field v-model="selectedUser.FullName" label="Họ tên" outlined></v-text-field>
                    <!-- <v-select v-model="selectedUser.VaiTro" :items="dataRole" item-title="RoleName" item-value="RoleID"
                        label="Vai trò" outlined></v-select> -->
                    <v-text-field v-model="selectedUser.Email" label="Email" outlined></v-text-field>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-btn color="gray" variant="flat" text @click="showDialogUpdate = false">Đóng</v-btn>
                    <v-btn color="success" variant="flat" text @click="saveUser">Lưu</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- xem quyền -->
        <v-dialog v-model="showDialogPermission" max-width="800px">
            <v-card prepend-icon="mdi-account-tie" title="Các quyền đang có">
                <v-divider></v-divider>
                <v-card-text>
                   <v-data-table-virtual hide-default-footer 
                   :group-by="[{ key: 'ProjectName', order: 'asc' }]"
                    :items="dsPermission" :headers="headerPermission"  >

                    <template v-slot:[`item.Permission`]="{item}">
                        <v-chip class="mx-1" v-for="p in JSON.parse(item.Permission)" :key="p">
                            {{ p.PermissionName }}
                        </v-chip>
                    </template>

               

                   </v-data-table-virtual>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-btn color="gray" variant="flat" text @click="showDialogPermission = false">Đóng</v-btn>
                  
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Hộp thoại xác nhận xóa -->
        <v-dialog v-model="showDialogDelete" max-width="400px">
            <v-card>
                <v-card-title>Xác nhận xóa</v-card-title>
                <v-card-text>Bạn có chắc chắn muốn xóa người dùng này không?</v-card-text>
                <v-card-actions>
                    <v-btn color="gray" text @click="showDialogDelete = false">Hủy</v-btn>
                    <v-btn color="red" variant="flat" text @click="deleteUser">Xóa</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import axios from "../utils/axios";

export default {
    name: "QuanLyNguoiDungComponent",
    data: () => ({
        userList: [],
        headers:[
            {title: "Username", key: "Username"},
            {title: "Fullname", key: "FullName"},
            {title: "Email", key: "Email"},
            
        ],
        headerPermission:[
           
            {title: "Module", key: "ModuleName"},
            {title: "Permission", key: "Permission"},
            
        ],
        dsPermission: [],
        dataCompany: [],
        cbxCompany: null,
        showDialogUpdate: false,
        showDialogDelete: false,
        showDialogPermission: false,
        selectedUser: {},
        dialogTitle: "",
        dataRole: [],
        errorMessage: "",
        colorMessage: "red",

    }),

    mounted() {
        this.getUsers();
        this.getCompany();
    },

    watch: {
        cbxCompany() {
            this.getUsers()
              
        }
    },

    methods: {
        getUsers() {
            this.userList = []
            axios
                .post("/User_SelectByCompany", {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem("auth")}` // Token lấy từ localStorage hoặc nơi lưu trữ của bạn
                    },
                    CompanyID: this.cbxCompany

                })
                .then((response) => {
                    console.log("API Response:", response.data);
                    this.userList = response.data || [];
                })
                .catch((error) => {
                    console.error("Error fetching users:", error);
                });
        },

        getCompany() {
            axios.get('/Company_SelectAll', {})
                .then((response) => { this.dataCompany = [...response.data] })
                .catch((error) => { console.log(error); });
        },

        getRole() {
            this.dataRole = []
            axios.post('/Role_SelectByCompany', {
                CompanyID: this.cbxCompany
            })
                .then((response) => { this.dataRole = [...response.data] })
                .catch((error) => { console.log(error); });
        },

        openDialogUpdateUser(user) {
            this.showDialogUpdate = true;
            if (user) {
                this.dialogTitle = "Chỉnh sửa người dùng";
                this.selectedUser = { ...user };
            } else {
                this.dialogTitle = "Thêm mới người dùng";
                this.selectedUser = {
                    Username: "",
                    FullName: "",
                    VaiTro: false,
                    Email: "",
                    CompanyID: this.cbxCompany
                };
            }
        },

        // Lưu dữ liệu Thêm/Sửa
        saveUser() {
            console.log(this.selectedUser)
            const url = this.selectedUser.UserID ? "/updateInfo" : "https://api.udf.com.vn/user/add";
            axios
                .post(url, this.selectedUser)
                .then((response) => {
                    this.errorMessage = response.data.message;
                    this.colorMessage = "blue";
                    this.showDialogUpdate = false;
                    this.getUsers();
                })
                .catch((error) => {
                    this.errorMessage = error.response?.data?.message || "Lỗi không xác định";
                    this.colorMessage = "red";
                });
        },

        // Xác nhận xóa
        confirmDelete(user) {
            this.selectedUser = user;
            this.showDialogDelete = true;
        },

        // Xóa người dùng
        deleteUser() {
            axios
                .post("https://api.udf.com.vn/user/delete", this.selectedUser)
                .then((response) => {
                    this.errorMessage = response.data.message;
                    this.colorMessage = "blue";
                    this.showDialogDelete = false;
                    this.getUsers();
                })
                .catch((error) => {
                    this.errorMessage = error.response?.data?.message || "Lỗi không xác định";
                    this.colorMessage = "red";
                });
        },

        async getPermission(UserID){
            this.dsPermission = [];
            this.dsPermission = await axios.post("https://api.udf.com.vn/user/Permission_Select_ByUser",
            {
                UserID: UserID
            }
            )
            .then((resp)=> resp.data || [])
            .catch((error) => {
                    this.errorMessage = error.response?.data?.message || "Lỗi không xác định";
                    this.colorMessage = "red";
                });
        }

    },
};
</script>

<style scoped>
.my-3 {
    margin: 16px 0;
}
</style>
